import { FREE_SHIPPING_THRESHOLD, STANDARD_SHIPPING } from "../constants";
export const addDecimals = (num) => {
    return (Math.round(num * 100) / 100).toFixed(2);
}

export const updateCart = (state) => {
    // Calculate items price
    state.itemsPrice = addDecimals(state.cartItems.reduce((acc, item) => acc + item.price * item.qty, 0));

    // Calculate shipping price - standard delivery is free from the threshold
    // (keep in sync with backend/utils/calcPrices.js)
    state.shippingPrice = addDecimals(Number(state.itemsPrice) >= FREE_SHIPPING_THRESHOLD ? 0 : STANDARD_SHIPPING);

    // itemsPrice is VAT-inclusive (UK 20%), so extract rather than add the VAT portion: price / 6
    state.taxPrice = addDecimals(Number((state.itemsPrice / 6).toFixed(2)));

    // VAT is already included in itemsPrice, so don't add it again here
    state.totalPrice = (
        Number(state.itemsPrice) +
        Number(state.shippingPrice)
    ).toFixed(2);

    // Strip guestEmail before persisting — it's session state only,
    // should not survive a browser close/reopen
    const { guestEmail, ...persistableState } = state;
    localStorage.setItem('cart', JSON.stringify(persistableState));

    return state;
}